var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeIcon = function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.515 7.83-.002-.002L10.171.486A1.65 1.65 0 0 0 8.999 0c-.442 0-.859.172-1.172.485L.49 7.824l-.008.008a1.659 1.659 0 0 0 1.154 2.825h.293v5.404c0 1.069.87 1.939 1.94 1.939H6.74a.527.527 0 0 0 .527-.527v-4.237c0-.488.397-.885.885-.885h1.694c.488 0 .885.397.885.885v4.237c0 .29.236.527.527.527h2.873c1.07 0 1.94-.87 1.94-1.94v-5.403h.271c.443 0 .859-.172 1.172-.485a1.66 1.66 0 0 0 0-2.343"
  })));
};
export default SvgHomeIcon;